import { inject, Injectable } from '@angular/core'
import { ApiHttpService } from './api.service'

@Injectable(
    {providedIn: 'root'}
)
export class UserNewsService {
    apiService = inject(ApiHttpService);

    getPrivacyPolicy() {
        return this.apiService.get('forumTalkSystemText/privacy');
    }

    getNetiquette() {
        return this.apiService.get('forumTalkSystemText/netiquette');
    }

    getBanner() {
        return this.apiService.get('forumTalkBanner');
    }
}
